// context/AuthProvider.js
import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../firebase'; // Import Firebase auth instance
import { onAuthStateChanged } from 'firebase/auth';

// Create a context
export const AuthContext = createContext();

// AuthProvider component to provide authentication state
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
};
